import * as names from '@/store/names';
import { APP_NAME } from "@/utils/globals";
import * as get from '@/store/store';
import restful from '@/utils/restful';

const state = {
    allows_crud: sessionStorage.getItem('allows_crud') === 'true',
    visibility_crud: false,
    print_orientation: false,
    title_of_the_print: APP_NAME,
    print_zoom_scale: 1,
    numbers_to_words: [],
    user_language: localStorage.getItem('user_language') || 'es',
    languages: [],
    matter_language_context: null,
};

const getters = {
    [names.NUMBERS_TO_WORDS]: state => {
        return state.numbers_to_words;
    },
    [names.ALLOWS_CRUD]: state => {
        return state.allows_crud;
    },
    [names.VISIBILITY_CRUD]: state => {
        return state.visibility_crud;
    },
    [names.PRINT_ZOOM_SCALE]: state => {
        return state.print_zoom_scale;
    },
    [names.PRINT_ORIENTATION]: state => {
        return state.print_orientation;
    },
    [names.TITLE_OF_THE_PRINT]: state => {
        return state.title_of_the_print;
    },
    [names.USER_LANGUAGE]: state => {
        return state.user_language;
    },
    [names.LANGUAGES]: state => {
        return state.languages;
    },
    [names.MATTER_LANGUAGE_CONTEXT]: state => {
        return state.matter_language_context;
    },
    getLocalVariable: (state, getters) => (component, variable) => {
        if (get.store.state.user) {
            const userId = get.store.state.user.id
            return getters.getLocalVariableByUser(component, variable, userId)
        }
        // Lista de variables usadas: 
        // hide_number, hide_dimension, hide_weighing, hide_evaluation_criteria, parameters_ai.
    },
    getLocalVariableByUser: () => (component, variable, userId) => {
        return JSON.parse(localStorage.getItem(`${component}&${variable}&${userId}`)) || false;
    },
};

const mutations = {
    [names.MUTATE_ALLOWS_CRUD]: (state, allows_crud) => {
        state.allows_crud = allows_crud;
        sessionStorage.setItem('allows_crud', allows_crud);
    },
    [names.MUTATE_VISIBILITY_CRUD]: (state, visibility_crud) => {
        state.visibility_crud = visibility_crud;
    },
    [names.MUTATE_PRINT_ZOOM_SCALE]: (state, print_zoom_scale) => {
        state.print_zoom_scale = print_zoom_scale;
    },
    [names.RESET_PRINT_ZOOM_SCALE]: (state) => {
        state.print_zoom_scale = 0;
    },
    [names.MUTATE_PRINT_ORIENTATION]: (state, print_orientation) => {
        state.print_orientation = print_orientation;
    },
    [names.RESET_PRINT_ORIENTATION]: (state) => {
        state.print_orientation = null;
    },
    [names.MUTATE_TITLE_OF_THE_PRINT]: (state, title_of_the_print) => {
        state.title_of_the_print = title_of_the_print;
    },
    [names.RESET_TITLE_OF_THE_PRINT]: (state) => {
        state.title_of_the_print = null;
    },
    ['MUTATE_NUMBERS_TO_WORDS']: (state, mutate) => {
        state.numbers_to_words = mutate;
    },
    [names.SET_USER_LANGUAGE]: (state, language) => {
        state.user_language = language;
        localStorage.setItem('user_language', language);
    },
    [names.MUTATE_LANGUAGES]: (state, languages) => {
        state.languages = languages;
    },
    [names.SET_MATTER_LANGUAGE_CONTEXT]: (state, context) => {
        state.matter_language_context = context;
    },
    [names.CLEAR_MATTER_LANGUAGE_CONTEXT]: (state) => {
        state.matter_language_context = null;
    },
    setLocalVariable: (state, { component, variable, value }) => {
        const userId = get.store.state.user.id
        localStorage.setItem(`${component}&${variable}&${userId}`, JSON.stringify(value));
        // Lista de variables usadas: 
        // hide_number, hide_dimension, hide_weighing, hide_evaluation_criteria, parameters_ai.
    },
};
const actions = {
    [names.FETCH_LANGUAGES]: ({ commit, state }, force) => {
        return new Promise((resolve) => {
            if (!force && state.languages.length > 0) {
                resolve(state.languages);
                return;
            }
            restful.GetAll('/common/language/')
                .then(response => {
                    commit(names.MUTATE_LANGUAGES, response);
                    resolve(response);
                });
        });
    },
    ["CHECK_NUMBERS_TO_WORDS"]: ({ commit, state }, check_number) => {
        return new Promise((resolve) => {
            if (parseInt(check_number) <= state.numbers_to_words.length) {
                resolve(state.numbers_to_words);
                return;
            } else {
                const unidades = ['PRIMER', 'SEGUNDO', 'TERCER', 'CUARTO', 'QUINTO', 'SEXTO', 'SÉPTIMO', 'OCTAVO', 'NOVENO'];
                const decenas = ['DÉCIMO', 'VIGÉSIMO', 'TRIGÉSIMO', 'CUADRAGÉSIMO', 'QUINCUAGÉSIMO', 'SEXAGÉSIMO', 'SEPTUAGÉSIMO', 'OCTOGÉSIMO', 'NONAGÉSIMO'];
                let numbers_to_words = [...state.numbers_to_words];
                for (let i = state.numbers_to_words.length + 1; i <= parseInt(check_number); i++) {
                    let nombre = '';
                    if (i <= 9) {
                        nombre = unidades[i - 1];
                    } else if (i % 10 === 0) {
                        let decena = Math.floor(i / 10);
                        nombre = decenas[decena - 1];
                    } else {
                        let decena = Math.floor(i / 10);
                        let unidad = i % 10;
                        nombre = decenas[decena - 1] + ` ${unidades[unidad - 1]}`;
                    }
                    numbers_to_words.push(nombre);
                }
                // Usar una mutación para actualizar el estado.
                commit('MUTATE_NUMBERS_TO_WORDS', numbers_to_words);
                resolve(numbers_to_words);
            }
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};